// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    // UI
    sectionSettings: "Section Settings",
    back: "Back",
    globalScope: "Global",
    perGoalScope: "Per Goal",
    perPortfolioScope: "Per Portfolio",
    add2ColumnBlock: "Add 2-Column Block",
    addComponent: "Add Component",
    add: "Add",
    component: "Component",
    twoColumnBlockLabel: "2-Column Block",
    noComponentsYet: "No components yet.",
    addComponentsDescription: "Add components or 2-column blocks to build your PDF template.",
    leftColumn: "Left Column",
    rightColumn: "Right Column",
    twoColumnLayoutBlock: "2-Column Layout Block",
    dropComponentHere: "Drop component here",
    noComponents: "No components",
    movingComponent: "Moving component...",
    // Confirmations
    deleteComponent: "Delete Component",
    deleteComponentConfirmation: "Are you sure you want to delete this component?",
    delete2ColumnBlock: "Delete 2-Column Block",
    delete2ColumnBlockConfirmation:
      "Are you sure you want to delete this 2-column block? All components inside will be deleted.",
    samePageBlockLabel: "Same Page Block",
    samePageBlockHint: "Everything inside is printed on the same page, if it fits.",
    components: "Components",
    deleteSamePageBlock: "Delete Same Page Block",
    deleteSamePageBlockConfirmation:
      "Are you sure you want to delete this Same Page Block? All components inside will be deleted.",
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    ok: "OK",
    failedToDelete: "Failed to delete",
    failedToCreate: "Failed to create",
    failedToReorder: "Failed to reorder",
    failedToDuplicate: "Failed to duplicate",
    duplicateComponent: "Duplicate component",
    conditional: "Conditional",
  },
  nb_NO: {
    settings: "Innstillinger",
    // UI
    sectionSettings: "Seksjonsinnstillinger",
    back: "Tilbake",
    globalScope: "Global",
    perGoalScope: "Per mål",
    perPortfolioScope: "Per portefølje",
    add2ColumnBlock: "Legg til 2-kolonneblokk",
    addComponent: "Legg til komponent",
    add: "Legg til",
    component: "Komponent",
    twoColumnBlockLabel: "2-kolonneblokk",
    noComponentsYet: "Ingen komponenter ennå.",
    addComponentsDescription:
      "Legg til komponenter eller 2-kolonneblokker for å bygge PDF-malen din.",
    leftColumn: "Venstre kolonne",
    rightColumn: "Høyre kolonne",
    twoColumnLayoutBlock: "2-kolonne layoutblokk",
    dropComponentHere: "Slipp komponent her",
    noComponents: "Ingen komponenter",
    movingComponent: "Flytter komponent...",
    // Confirmations
    deleteComponent: "Slett komponent",
    deleteComponentConfirmation: "Er du sikker på at du vil slette denne komponenten?",
    delete2ColumnBlock: "Slett 2-kolonneblokk",
    delete2ColumnBlockConfirmation:
      "Er du sikker på at du vil slette denne 2-kolonneblokken? Alle komponenter inni vil bli slettet.",
    samePageBlockLabel: "Samme side-blokk",
    samePageBlockHint: "Alt i blokken skrives ut på samme side, hvis det får plass.",
    components: "Komponenter",
    deleteSamePageBlock: "Slett Samme side-blokk",
    deleteSamePageBlockConfirmation:
      "Er du sikker på at du vil slette denne Samme side-blokken? Alle komponenter inni vil bli slettet.",
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    ok: "OK",
    failedToDelete: "Kunne ikke slette",
    failedToCreate: "Kunne ikke opprette",
    failedToReorder: "Kunne ikke endre rekkefølge",
    failedToDuplicate: "Kunne ikke duplisere",
    duplicateComponent: "Dupliser komponent",
    conditional: "Betinget",
  },
} as const;
